import React, { useEffect, useState } from "react";
import AboutArea from "../../components/About/AboutArea";
import BannerOne from "../../components/Banner/BannerOne";
import BlogArea from "../../components/Blog/BlogArea";
import ConsultationArea from "../../components/Consultation/ConsultationArea";
import NewsLetterArea from "../../components/NewsLetter/NewsLetterArea";
import ProjectArea from "../../components/Project/ProjectArea";
import ServicesArea from "../../components/ServicesArea/ServicesArea";
import TeamArea from "../../components/Team/TeamArea";
import TestimonialArea from "../../components/Testimonial/TestimonialArea";
import Layout from "../../layouts/Layout";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

const CreativeAgency = () => {


  return (
    <>
      <Helmet>
        <title>Innovatix Hub: Creative Graphic Design Agency in Hobart, TAS</title>
        <meta
          name="description"
          content="Innovatix Hub is a creative graphic design agency in Hobart, TAS. Our team of graphic designers specialises in graphic design services across Australia."
        />
        <meta name="robots" content="index,follow" />
        <meta name="author" content="Innovatix Hub AU" />
        <meta
          property="og:title"
          content="Innovatix Hub: Creative Graphic Design Agency in Hobart, TAS"
        />
        <meta
          property="og:description"
          content="Innovatix Hub is a creative graphic design agency in Hobart, TAS. Our team of graphic designers specialises in graphic design services across Australia."
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_AU" />
        <meta property="og:site_name" content="Innovatix Hub AU" />
        <meta property="og:url" content="https://innovatixhub.com.au/" />
        <meta
          property="og:image"
          content="https://innovatixhub.com.au/img/logo1.png"
        />

        <link rel="canonical" href="https://innovatixhub.com.au/" />
      </Helmet>
      <Layout header={1} footer={1}>
        <BannerOne />
        <section className="py-35 container px-35">
          <div className="d-flex" style={{justifyContent: "center", alignItems: "center", gap: "6rem", marginBottom: "6rem"}}>
            <Link to="https://clutch.co/profile/innovatix-hub-au
"><img src="/img/verify/1.webp" alt="" className=""/></Link>
            <Link to="https://www.goodfirms.co/company/innovatix-hub-australia
"><img src="/img/verify/2.webp" alt="" className=""/></Link>
            <Link to="https://au.trustpilot.com/review/innovatixhub.com.au 
"><img src="/img/verify/3.webp" alt="" className=""/></Link>
          </div>
        </section>
        <ServicesArea />
        <AboutArea />
        <TeamArea />
        <ProjectArea />
        <TestimonialArea />
        <ConsultationArea />
        {/* <BlogArea /> */}
        <NewsLetterArea />
      </Layout>
    </>
  );
};

export default CreativeAgency;
